export default {
  ADD_TOPICS(state, topics) {
    state.topics.list = state.topics.list.concat(topics.list);
    state.topics.count = topics.count;
  },
  RESET_STATE(state) {
    Object.assign(state, initialState());
  },
  SET_TOPIC_DETAIL(state, topicDetail) {
    state.topicDetail = topicDetail;
  },
  SET_TOPICS_IN_FIVE_DAYS(state, topicsInFiveDays) {
    state.topicsInFiveDays = topicsInFiveDays;
  },
};
export const initialState = () => ({
  topics: { list: [], count: 0 },
  topicsInFiveDays: [],
  topicDetail: {},
});
